import { render } from "./maternity_investigations.vue?vue&type=template&id=4e7e8a20&scoped=true"
import script from "./maternity_investigations.vue?vue&type=script&lang=js"
export * from "./maternity_investigations.vue?vue&type=script&lang=js"

import "./maternity_investigations.vue?vue&type=style&index=0&id=4e7e8a20&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e7e8a20"]])

export default __exports__